import script from "./BaseItemDialogPricing.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseItemDialogPricing.vue?vue&type=script&setup=true&lang=ts"

import "./BaseItemDialogPricing.vue?vue&type=style&index=0&id=3bb4bb4f&lang=sass&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bb4bb4f"]])

export default __exports__